export default __webpack_public_path__ + "static/media/extend.c21b789c.jpg";